import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HelperService } from '../helper.service';
import { HttpClient } from '@angular/common/http';
import { FuelOption } from 'src/app/models/option.model';
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class VesselCalculationInventoryService {


  environmentUrl = "Debug api";
  constructor(
    private http: HttpClient,
    private helperService: HelperService
  ) {
    this.environmentUrl = environment.apiUrl;
  }

  public addLCS(createLifeCycleScenariosDto: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/add-life-cycle-scenarios`,
      createLifeCycleScenariosDto,
      this.helperService.headers()
    );
  }

  public getOptionDataForLifeCycleScenario(title: any): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/options-lifecycle/${title}`,
      this.helperService.headers()
    );
  }


  public getFuelConsumptionAndType(title: any, id: any): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/options-lifecycle/${title}`,
      this.helperService.headers()
    );
  }

  public addScenarioInventory(option: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/add-scenario-inventory`,
      option,
      this.helperService.headers()
    );
  }


  public updateScenarioInventory(option: any): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/update-scenario-inventory/${option.id}`,
      option,
      this.helperService.headers()
    );
  }

  public deleteScenarioInventory(id: any): Observable<any> {
    return this.http.delete<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/delete-scenario-inventory/${id}`,
      this.helperService.headers()
    );
  }

  public getOptionsByLifeCycleScenarioId(id: any): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/options/${id}`,
      this.helperService.headers()
    );
  }

  public confirmLifeCycleScenario(id: any): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/confirm-life-cycle-scenario/${id}`,
      this.helperService.headers()
    );
  }

  public getScope1Impact(id: any): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/scope1-impact/${id}`,
      this.helperService.headers()
    );
  }

  public getScope2Impact(id: any): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/scope2-impact/${id}`,
      this.helperService.headers()
    );
  }

  public getScope3Impact(id: any, vesselType): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/${id}/scope3-${vesselType}`,
      this.helperService.headers()
    );
  }

  public getOptions(): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/getFuelOptions`,
      this.helperService.headers()
    );
  }

  public addOption(option: FuelOption): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/addFuelOption`,
      option,
      this.helperService.headers()
    );
  }

  deleteOption(id: string): Observable<any> {
    return this.http.delete<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/deleteFuelOption/${id}`
    );
  }

  updateOption(option: FuelOption): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/updateFuelOption/${option.id}`,
      option,
      this.helperService.headers()

    );
  }

  public getScenarioCategory(): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/all-scenario-category`,
      this.helperService.headers()
    );
  }

  public createScenarioCategory(category: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/scenario-category/create`,
      category,
      this.helperService.headers()
    );
  }

  updateScenarioCategory(category: any): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/scenario-category/update/${category.id}`,
      category,
      this.helperService.headers()
    );
  }
  getScenarioCategoryById(id: string): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/scenario-category/${id}`,
      this.helperService.headers()
    );
  }

  public getFuelOptions(): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/fuelOption`,
      this.helperService.headers()
    );
  }

  public getRecyclingOptions(): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/RecyclingOptions`,
      this.helperService.headers()
    );
  }

  public getEnergyOptions(): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/energyOptions`,
      this.helperService.headers()
    );
  }

  public getSteelSourceOptions(): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/SteelSourceOptions`,
      this.helperService.headers()
    );
  }
  createFuelOption(fuelOption: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/create-fuel-option`,
      fuelOption,
      this.helperService.headers()
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }

  createRecyclingOption(recyclingOption: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/create-recycling-option`,
      recyclingOption,
      this.helperService.headers()
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }

  public createEnergyOption(energyOption: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/create-energy-option`,
      energyOption,
      this.helperService.headers()
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }

  createSteelSourceOption(steelSourceOption: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/create-steel-source-option`,
      steelSourceOption,
      this.helperService.headers()
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }

  editFuelOption(id: number, fuelOption: any): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/update-fuel-option/${id}`,
      fuelOption,
      this.helperService.headers()
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }

  editRecyclingOption(id: number, recyclingOption: any): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/update-recycling-option/${id}`,
      recyclingOption,
      this.helperService.headers()
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }
  public getAvailableCountries(): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/available-countries`,
      this.helperService.headers()
    );
  }
  editEnergyOption(id: number, energyOption: any): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/update-energy-option/${id}`,
      energyOption,
      this.helperService.headers()
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }

  editSteelSourceOption(id: number, steelSourceOption: any): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/update-steel-source-option/${id}`,
      steelSourceOption,
      this.helperService.headers()
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }
  getFuelOptionById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/fuel-option/${id}`,
      this.helperService.headers()
    );
  }

  getRecyclingOptionById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/recycling-option/${id}`,
      this.helperService.headers()
    );
  }

  getEnergyOptionById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/energy-option/${id}`,
      this.helperService.headers()
    );
  }

  getSteelSourceOptionById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/steel-source-option/${id}`,
      this.helperService.headers()
    );
  }
  deleteFuelOption(id: string): Observable<any> {
    return this.http.delete<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/delete-fuel-option/${id}`
    );
  }

  deleteRecyclingOption(id: string): Observable<any> {
    return this.http.delete<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/delete-recycling-option/${id}`
    );
  }

  deleteEnergyOption(id: string): Observable<any> {
    return this.http.delete<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/delete-energy-option/${id}`,
      this.helperService.headers()
    );
  }

  deleteSteelSourceOption(id: string): Observable<any> {
    return this.http.delete<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/delete-steel-source-option/${id}`
    );
  }
  getCategoriesForFuel(): Observable<any[]> {
    return this.http.get<any[]>(`${this.environmentUrl}/api/vessel-calculation-inventory/v2/all-scenario-category-fuel`);
  }

  getCategoriesForRecycling(): Observable<any[]> {
    return this.http.get<any[]>(`${this.environmentUrl}/api/vessel-calculation-inventory/v2/all-scenario-category-recycling`);
  }

  getCategoriesForEnergy(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/all-scenario-category-energy`,
      this.helperService.headers()
    );
  }

  getCategoriesForSteelSource(): Observable<any[]> {
    return this.http.get<any[]>(`${this.environmentUrl}/api/vessel-calculation-inventory/v2/all-scenario-category-steel-source`);
  }
  updateStatusToCompleted(vesselId: number): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-life-cycle/UpdateStatusToCompleted/${vesselId}`,
      {},
      this.helperService.headers()
    );
  }

  public getVesselFuelScenario(vesselId: number, vesselCustomCalculationId: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/${vesselId}/scenarios/${vesselCustomCalculationId}/fuel`,
      this.helperService.headers()
    );
  }

  public getVesselScenarios(id: number, scenarioId?: number): Observable<any> {
    let url = `${this.environmentUrl}/api/vessel-calculation-inventory/vessels/${id}/scenarios`;
    if (scenarioId !== undefined && scenarioId !== null) {
      url += `?scenario_id=${scenarioId}`;
    }
    return this.http.get<any>(url, this.helperService.headers());
  }

  public getAllScenarioNames(): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/vessel/scenarios`,
      this.helperService.headers()
    );
  }

  public createVesselScenario(vesselId: number, request: { name: string, scenarioId: number }): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/vessels/${vesselId}/create-scenarios`,
      request,
      this.helperService.headers()
    );
  }

  public updateVesselFuelScenario(vesselId: number, vesselScenarioId: number, fuelOptions: any[]): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/${vesselId}/scenarios/update/${vesselScenarioId}/fuel`,
      fuelOptions,
      this.helperService.headers()
    );
  }

  public updateVesselRecyclingScenario(vesselId: number, vesselScenarioId: number, recyclingOptions: any[]): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/${vesselId}/scenarios/update/${vesselScenarioId}/recycling`,
      recyclingOptions,
      this.helperService.headers()
    );
  }

  public getVesselRecyclingScenario(vesselId: number, vesselCustomCalculationId: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/${vesselId}/scenarios/${vesselCustomCalculationId}/recycling`,
      this.helperService.headers()
    );
  }

  public getVesselSteelScenario(vesselId: number, vesselCustomCalculationId: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/${vesselId}/scenarios/${vesselCustomCalculationId}/steel-source`,
      this.helperService.headers()
    );
  }

  public updateVesselSteelScenario(vesselId: number, vesselScenarioId: number, steelOptions: any[]): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/${vesselId}/scenarios/update/${vesselScenarioId}/steel-source`,
      steelOptions,
      this.helperService.headers()
    );
  }

  public getVesselEnergyScenario(vesselId: number, vesselCustomCalculationId: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/${vesselId}/scenarios/${vesselCustomCalculationId}/energy-assembly`,
      this.helperService.headers()
    );
  }

  public updateVesselEnergyScenario(vesselId: number, vesselScenarioId: number, energyOptions: any[]): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/vessel-calculation-inventory/v2/${vesselId}/scenarios/update/${vesselScenarioId}/energy-assembly`,
      energyOptions,
      this.helperService.headers()
    );
  }

  downloadPdf(pdfType: string, vesselId: number, scenarioId: number): Observable<Blob> {
    const url = `/api/vessel-export/generatePdf/${pdfType}/${vesselId}/${scenarioId}`;
    return this.http.get(url, { responseType: 'blob' });
  }
    public getAllVesselSubgroups(): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/vessels/get-all-vessel-subgroups`,
      this.helperService.headers()
    );
  }
  createVesselSubgroups(vesselSubgroup: any): Observable<any> {
  return this.http.post<any>(
    `${this.environmentUrl}/api/vessels/create-vessel-subgroups`,
    vesselSubgroup,
    this.helperService.headers()
  ).pipe(
    catchError(error => {
      throw error;
    })
  );
}
getVesselSubgroups(vesselType: string, subType: string): Observable<any> {
  return this.http.get<any>(
    `${this.environmentUrl}/api/vessels/get-vessel-subgroups/${vesselType}/${subType}`,
    this.helperService.headers()
  ).pipe(
    catchError(error => {
      throw error;
    })
  );
}

updateVesselSubgroups(vesselType: string, subType: string, dto: any): Observable<any> {
  return this.http.put<any>(
    `${this.environmentUrl}/api/vessels/update-vessel-subgroups/${vesselType}/${subType}`,
    dto,
    this.helperService.headers()
  ).pipe(
    catchError(error => {
      throw error;
    })
  );
}

public deleteVesselSubgroup(id: number): Observable<any> {
  return this.http.delete<any>(
    `${this.environmentUrl}/api/vessels/delete-vessel-subgroup/${id}`,
    this.helperService.headers()
  );
}




}